module.exports = __webpack_public_path__ + "img/6.de7c2a7.jpg";